import { BrokerAgent, BrokerFirm, NewOrder } from '../types';

export function initialBrokerAgentId(newOrder: NewOrder, loggedInUserId: number): number | null {
    const wantedId = newOrder.pendingOrder ? newOrder.pendingOrder.userId : loggedInUserId;
    const agent = newOrder.availableBrokerAgents.find((candidate) => candidate.id === wantedId);
    return agent ? agent.id : null;
}

export function brokerFirmsOf(newOrder: NewOrder, brokerAgentId: number | null): BrokerFirm[] {
    const agent = newOrder.availableBrokerAgents.find(
        (candidate: BrokerAgent) => candidate.id === brokerAgentId
    );
    if (!agent) {
        return [];
    }

    return [
        ...agent.availableBrokerFirms.filter((firm) => firm.isHeadQuarter),
        ...agent.availableBrokerFirms.filter((firm) => !firm.isHeadQuarter)
    ];
}

export function initialBrokerFirmId(
    newOrder: NewOrder,
    brokerAgentId: number | null
): number | null {
    const firms = brokerFirmsOf(newOrder, brokerAgentId);
    const pendingOrderFirm = firms.find((firm) => firm.id === newOrder.pendingOrderBrokerFirmId);
    const firm = pendingOrderFirm || firms[0];
    return firm ? firm.id : null;
}
